import React, { useEffect } from "react"
import { OurClients } from "../../features/our-clients"
import { Gallery } from "../../features/gallery"
import ArrowRight from "../../components/icons/ArrowRight"
import LazyImage from "../../components/LazyImage"
import TechnologiesList from "../../features/technologies-list"
import { useMediaQuery } from "react-responsive"
import { DESKTOP_WIDTH } from "../../constants/common"
import BigNumList from "../../features/big-num-list"
import {
    OUR_TEAM_AUGMENTATION_SERVICES_DESKTOP_LIST,
    OUR_TEAM_AUGMENTATION_SERVICES_MOBILE_LIST,
    WHY_TEAM_AUGMENTATION_WITH_US,
} from "../../data/team-augmentation/teams"
import { OUR_TEAM_AUGMENTATION_PROCESS } from "../../data/team-augmentation/process"
import AndroidLogo from "../../assets/images/technologies/Android.svg"
import PythonLogo from "../../assets/images/technologies/Python.svg"
import JavaLogo from "../../assets/images/technologies/Java.svg"
import FlutterLogo from "../../assets/images/technologies/Flutter.svg"
import NodeJSLogo from "../../assets/images/technologies/NodeJS.svg"
import JSLogo from "../../assets/images/technologies/JS.svg"
import IOSLogo from "../../assets/images/technologies/IOS.svg"
import ReactLogo from "../../assets/images/technologies/React.svg"
import { GetInTouch } from "../../utils"

import "./index.scss"
import { Helmet } from "react-helmet-async"

const TeamAugmentation = () => {
    const isDesktop = useMediaQuery({ minWidth: DESKTOP_WIDTH })

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet defer={false}>
                <title>Newsoft - Team augmentation</title>
            </Helmet>
            <div className="teamaugmentation">
                <div className="teamaugmentation-header">
                    <h3 className="t-h1-m">Team Augmentation</h3>
                    <p className="t-b4">
                        Extend your team quickly with our technical talents. Our
                        software developers possess extensive cross-industry
                        expertise and can help you build powerful products and
                        drive your business growth.
                    </p>
                    <a
                        onClick={() => {
                            GetInTouch()
                        }}
                        className="teamaugmentation-header-link t-nav hov-get-in-touch-black"
                    >
                        {" "}
                        get in touch
                        <ArrowRight width={26} color={"white"} />
                    </a>
                </div>
                <div className="teamaugmentation-image">
                    <LazyImage
                        src={
                            "https://s3.amazonaws.com/staging.newsoft-website-v2/media/team_augmentation/team+augmentation.webp"
                        }
                        alt="Newsoft people"
                    />
                </div>
                <TechnologiesList title="Our technology stack">
                    <img
                        src={PythonLogo}
                        alt="Python logo"
                        style={!isDesktop ? { width: "40px" } : {}}
                    ></img>
                    <img
                        src={JavaLogo}
                        alt="Java logo"
                        style={!isDesktop ? { width: "30px" } : {}}
                    ></img>
                    <img
                        src={IOSLogo}
                        alt="IOS logo"
                        style={!isDesktop ? { width: "56px" } : {}}
                    ></img>
                    <img
                        src={NodeJSLogo}
                        alt="NodeJS logo"
                        style={!isDesktop ? { width: "91px" } : {}}
                    ></img>
                    <img
                        src={JSLogo}
                        alt="JS logo"
                        style={!isDesktop ? { width: "35px" } : {}}
                    ></img>
                    <img
                        src={AndroidLogo}
                        alt="Android logo"
                        style={!isDesktop ? { width: "35px" } : {}}
                    ></img>
                    <img
                        src={FlutterLogo}
                        alt="Flutter logo"
                        style={!isDesktop ? { width: "111px" } : {}}
                    ></img>
                    <img
                        src={ReactLogo}
                        alt="React logo"
                        style={!isDesktop ? { width: "44px" } : {}}
                    ></img>
                </TechnologiesList>
                <BigNumList
                    header="Our team augmentation services"
                    list={
                        !isDesktop
                            ? OUR_TEAM_AUGMENTATION_SERVICES_DESKTOP_LIST
                            : OUR_TEAM_AUGMENTATION_SERVICES_MOBILE_LIST
                    }
                    className="big-num-list-dark"
                />
                <div className="teamaugmentation-with-us">
                    <h3 className="t-h1">Why Team Augmemtation with us</h3>
                    {!isDesktop && (
                        <div className="teamaugmentation-with-us-image">
                            <LazyImage
                                src="https://s3.amazonaws.com/staging.newsoft-website-v2/media/team_augmentation/teamaugmentation1_mobile.webp"
                                alt="Newsoft people"
                            ></LazyImage>
                        </div>
                    )}
                    <div className="teamaugmentation-with-us-items">
                        {WHY_TEAM_AUGMENTATION_WITH_US.map((el, id) => (
                            <div
                                key={id}
                                className="teamaugmentation-with-us-items-item"
                            >
                                <div className="teamaugmentation-with-us-items-item-image">
                                    <LazyImage src={el.image} alt="Newsoft team augmentation"/>
                                </div>
                                <div>
                                    <h2 className="t-s1">{el.header}</h2>
                                    <hr />
                                    <p className="teamaugmentation-with-us-items-item-text t-b4">
                                        {!isDesktop ? el.mobile_text : el.text}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="teamaugmentation-process">
                    <h3 className="t-h1">Our team Augmentation process</h3>
                    <div className="teamaugmentation-process-items">
                        {OUR_TEAM_AUGMENTATION_PROCESS.map((el, id) => (
                            <div
                                key={id}
                                className={`teamaugmentation-process-items-item ${
                                    el.number % 2 == 0 ? "reverse" : ""
                                }`}
                            >
                                <div className="teamaugmentation-process-items-item-image">
                                    <LazyImage src={el.image} alt="Newsoft team augmentation process" />
                                </div>
                                <div>
                                    <p className="teamaugmentation-process-items-item-step t-s6">{`Step ${el.number}`}</p>
                                    <h2 className="t-s1-m">{el.header}</h2>
                                    <hr />
                                    <p className="teamaugmentation-process-items-item-text t-b3">
                                        {el.text}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <OurClients />
            </div>
            <Gallery />
        </>
    )
}

export default TeamAugmentation
